var map = {
	"./template.bet575": 1921,
	"./template.bet575.tsx": 1921,
	"./template.bet777": 1922,
	"./template.bet777.tsx": 1922,
	"./template.betgalaxy": 1923,
	"./template.betgalaxy.tsx": 1923,
	"./template.betprofessor": 1924,
	"./template.betprofessor.tsx": 1924,
	"./template.betroyale": 2030,
	"./template.betroyale.tsx": 2030,
	"./template.betstride": 1925,
	"./template.betstride.tsx": 1925,
	"./template.buffalobet": 1926,
	"./template.buffalobet.tsx": 1926,
	"./template.chromabet": 1927,
	"./template.chromabet.tsx": 1927,
	"./template.default": 182,
	"./template.default.tsx": 182,
	"./template.epicodds": 1928,
	"./template.epicodds.tsx": 1928,
	"./template.fiestabet": 1929,
	"./template.fiestabet.tsx": 1929,
	"./template.forsport": 2147,
	"./template.forsport.tsx": 2147,
	"./template.gigabet": 1930,
	"./template.gigabet.tsx": 1930,
	"./template.goldenbet888": 1931,
	"./template.goldenbet888.tsx": 1931,
	"./template.goldenrush": 1932,
	"./template.goldenrush.tsx": 1932,
	"./template.hyperbet": 1933,
	"./template.hyperbet.tsx": 1933,
	"./template.juicybet": 1934,
	"./template.juicybet.tsx": 1934,
	"./template.junglebet": 1935,
	"./template.junglebet.tsx": 1935,
	"./template.magnumbet": 1936,
	"./template.magnumbet.tsx": 1936,
	"./template.puntcity": 2148,
	"./template.puntcity.tsx": 2148,
	"./template.puntgenie": 1937,
	"./template.puntgenie.tsx": 1937,
	"./template.pyramidbet": 1938,
	"./template.pyramidbet.tsx": 1938,
	"./template.questbet": 1939,
	"./template.questbet.tsx": 1939,
	"./template.slambet": 1940,
	"./template.slambet.tsx": 1940,
	"./template.sterlingparker": 1941,
	"./template.sterlingparker.tsx": 1941,
	"./template.templebet": 1942,
	"./template.templebet.tsx": 1942,
	"./template.titanbet": 1943,
	"./template.titanbet.tsx": 1943,
	"./template.ts": 998,
	"./template.vikingbet": 1944,
	"./template.vikingbet.tsx": 1944,
	"./template.volcanobet": 1945,
	"./template.volcanobet.tsx": 1945,
	"./template.wellbet": 2149,
	"./template.wellbet.tsx": 2149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2794;